import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";
import { AllTermsResponse, Term } from "../model/types";

// Helper to safely extract the data array from an API response.
const extractData = (apiResult: PromiseSettledResult<any>): Term[] => {
  // Check if the promise was fulfilled and the response value exists
  if (apiResult.status === 'fulfilled' && apiResult.value) {
    // Check if the actual data is nested in a .data property and is an array
    if (Array.isArray(apiResult.value.data)) {
      return apiResult.value.data;
    }
    // Check if the response value itself is the array
    if (Array.isArray(apiResult.value)) {
      return apiResult.value;
    }
  }
  // Log any rejected promises
  if (apiResult.status === 'rejected') {
    console.error("Failed to fetch term:", apiResult.reason);
  }
  // Return an empty array if data is missing, not an array, or if the promise was rejected
  return [];
};

export const termsService = {
  fetchAllTerms: async (): Promise<AllTermsResponse> => {
    const results = await Promise.allSettled([
      apiService.get<Term[]>(API_ENDPOINTS.TERMS.GET_EXPENDITURES),
      apiService.get<Term[]>(API_ENDPOINTS.TERMS.GET_FUNDING_RANGE),
      apiService.get<Term[]>(API_ENDPOINTS.TERMS.GET_FUNDING_TYPE),
      apiService.get<Term[]>(API_ENDPOINTS.TERMS.GET_SECTORS),
    ]);

    const expenditures = extractData(results[0]);
    const fundingRanges = extractData(results[1]);
    const fundingTypes = extractData(results[2]);
    const sectors = extractData(results[3]);

    return { expenditures, fundingRanges, fundingTypes, sectors };
  },
};